module.exports = __webpack_public_path__ + "img/Pistol_TH.12810795.png";